import { createFileRoute } from "@tanstack/react-router";
import { ArbejdspladsPage, arbejdspladsHead } from "@/pages/ArbejdspladsPage";

export const Route = createFileRoute("/mi-support-som-arbejdsplads")({
  head: () => arbejdspladsHead("da"),
  component: () => <ArbejdspladsPage locale="da" />,
});
